<template>
  <PageContentLayoutOnly role="region" surveys>
    <div class="level pl-5 pr-5">
      <div class="pt-5 level-left level-item title">{{ $t('surveys.detailsTitle') }}</div>
    </div>

    <LinksMenu
      aria-label="account settings tabs"
      :tabs="tabs"
      prefix="communityCenter."
      :style="{
        paddingLeft: '20px'
      }"
      :styles="{
        ul: {
          width: '155px'
        }
      }"
    >
      <section :style="{ overflowX: 'auto', flexGrow: 2, marginTop: '-30px' }">
        <SlideTransition :name="transitionName">
          <keep-alive>
            <router-view />
          </keep-alive>
        </SlideTransition>
      </section>
    </LinksMenu>
  </PageContentLayoutOnly>
</template>

<script>
import SlideTransition from '@/components/transitions/Slide.vue'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { hoaUtility } from '@/services/Hoa/store'
import { data } from './keys/data'
import { watch } from './keys/watch'
import { computed } from './keys/computed'

import LinksMenu from '@/components/menus/Links'

export default {
  components: {
    SlideTransition,
    PageContentLayoutOnly,
    LinksMenu
  },

  data,

  watch,

  computed,

  async mounted() {
    await this.retrieveFeatureList()
  },

  methods: {
    /**
     * Status of item, alter animation name based on action.
     */
    async retrieveFeatureList() {
      console.debug('in retrieveFeatureList()...')
      await hoaUtility
        .dispatch('getEnabledFeaturesList', {
          hoaID: this.hoaId
        })
        .then(({ list }) => {
          console.debug('retrieveFeatureList...' + JSON.stringify(list))
          if (list && list.length > 0) {
            console.debug(
              'getEnabledFeaturesList========Management Community Items=========================' +
                JSON.stringify(list)
            )

            let firstDynamicTabName = ''

            this.tabs.clear
            if (this.checkFeatureByList('calendar', list) === true) {
              this.tabs.push({ name: 'calendar', label: 'Calendar' })
              firstDynamicTabName = 'calendar'
            }

            this.tabs.push({ name: 'documentCenter', label: 'Published Documents' })

            if (this.checkFeatureByList('faqs', list) === true) {
              this.tabs.push({
                name: 'frequentlyAskedQuestions',
                label: 'Frequently Asked Questions'
              })

              if (firstDynamicTabName === '') {
                firstDynamicTabName = 'frequentlyAskedQuestions'
              }
            }

            if (this.checkFeatureByList('hoa-contacts', list) === true) {
              this.tabs.push({ name: 'hoaContacts', label: 'HOA Contacts' })

              if (firstDynamicTabName === '') {
                firstDynamicTabName = 'hoaContacts'
              }
            }

            //If there are no dynamic tabs added then make the first static tab the default
            if (firstDynamicTabName === '') {
              this.$router.replace('/communityCenter/documentCenter')
            } else if (firstDynamicTabName !== '') {
              this.$router.replace(`/communityCenter/${firstDynamicTabName}`)
            }
          }
        })

      return []
    },

    checkFeatureByList(permission, list) {
      console.debug('check checkFeatureByList=' + permission)
      let permissionSet = false
      if (list !== undefined && list && list.length > 0) {
        const filtered = list.filter(f => f === permission)[0]
        if (filtered !== undefined && filtered) {
          permissionSet = true
        }
      }

      console.debug('checkFeatureByList permission=' + permission + ', ' + permissionSet)

      return permissionSet
    }
  },

  i18n: {
    messages: {
      en: {
        surveys: {
          detailsTitle: 'Community Info'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.surveys {
  .owner-avatar {
    margin: 1em auto 2em;
  }

  .card {
    box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05) !important;

    .card {
      border: 0 !important;
    }
  }

  .avatar-img {
    border: 1px solid #e7e8f2;
    padding: 0.25em;
  }

  .address-card {
    h5,
    h6 {
      margin: 0;
    }
  }

  .details-img {
    img {
      border-radius: 0.5em;
    }
  }
}
</style>
